module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tip":"Please specify the reason. This will help us make our service better!","send":"Send","successMessage":"Thanks for the feedback"}}')
  delete Component.options._Ctor
}
